export default "__VITE_ASSET__1908bba4__"